import React, { Component } from 'react'

class ComponentAddPost extends Component {
  componentDidMount = () => {}

  render = () => <div>AddPost</div>
}

export { ComponentAddPost }
